import { KnowledgeBase } from '@feedyou/schema'
import { actions as flowActions } from '../../../../store/flow/flowSlice'
import { FeedbotThunk } from '../../../../store/types'

export const save =
  ({
    formData,
    initialFormData
  }: {
    formData: KnowledgeBase
    initialFormData: KnowledgeBase
  }): FeedbotThunk =>
  (dispatch, getState) => {
    const state = getState()
    const botFlow = state.flow?.present

    if (!botFlow) {
      throw new Error('No bot flow found')
    }

    const knowledgeBases = botFlow.knowledgeBases || []

    const updatedKnowledgeBases = initialFormData?.id
      ? knowledgeBases.map(kb => (kb.id === initialFormData.id ? formData : kb))
      : [...knowledgeBases, formData]

    dispatch(
      flowActions.setFlow({
        ...botFlow,
        knowledgeBases: updatedKnowledgeBases
      })
    )
  }
